// import React from 'react'
// import './Footer.css'

// function Footer() {
//   return (
//     <footer className="bg-gray-50 py-12 border-t">
//         <div className="container mx-auto px-4">
//           <div className="grid md:grid-cols-5 gap-8">
//             <div>
//               <h2 className="font-semibold text-gray-800 mb-4">About FoodExpress</h2>
//               <ul className="space-y-2 text-sm text-gray-600">
//                 <li><a href="#" className="hover:text-red-500">Who We Are</a></li>
//                 <li><a href="#" className="hover:text-red-500">Blog</a></li>
//                 <li><a href="#" className="hover:text-red-500">Work With Us</a></li>
//                 <li><a href="#" className="hover:text-red-500">Contact Us</a></li>
//               </ul>
//             </div>

//             <div>
//               <h2 className="font-semibold text-gray-800 mb-4">Our Services</h2>
//               <ul className="space-y-2 text-sm text-gray-600">
//                 <li><a href="#" className="hover:text-red-500">Takeaway</a></li>
//                 <li><a href="#" className="hover:text-red-500">Online Ordering</a></li>
//                 <li><a href="#" className="hover:text-red-500">Catering</a></li>
//                 <li><a href="#" className="hover:text-red-500">Group Orders</a></li>
//               </ul>
//             </div>

//             <div>
//               <h2 className="font-semibold text-gray-800 mb-4">For Restaurants</h2>
//               <ul className="space-y-2 text-sm text-gray-600">
//                 <li><a href="/partner" className="hover:text-red-500">Partner With Us</a></li>
//                 <li><a href="#" className="hover:text-red-500">Apps For You</a></li>
//               </ul>
//             </div>

//             <div>
//               <h2 className="font-semibold text-gray-800 mb-4">For You</h2>
//               <ul className="space-y-2 text-sm text-gray-600">
//                 <li><a href="#" className="hover:text-red-500">Privacy</a></li>
//                 <li><a href="#" className="hover:text-red-500">Security</a></li>
//                 <li><a href="#" className="hover:text-red-500">Terms</a></li>
//                 <li><a href="#" className="hover:text-red-500">Sitemap</a></li>
//               </ul>
//             </div>

//             <div>
//               <h2 className="font-semibold text-gray-800 mb-4">Social Links</h2>
//               <div className="flex space-x-4">
//                 <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
//                 <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
//                 <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
//                 <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
//               </div>
//             </div>
//           </div>

//           <hr className="my-8 border-gray-200" />
//           <div className="text-center text-sm text-gray-500">
//             By continuing past this page, you agree to our Terms of Service, Cookie Policy, Privacy Policy and Content Policies. All trademarks are properties of their respective owners. 2008-2025 © FoodExpress™ Ltd. All rights reserved.
//           </div>
//         </div>
//       </footer>
//   );
// }

// export default Footer;

import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-darkbg text-snowtxt py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-redtxt">
              GrabGrub
            </h2>
            <p className="text-snowtxt text-lg max-w-3xl mx-auto leading-relaxed">
              Your go-to destination for quick, and easy takeaway from the campus canteen.
            </p>
          </div>

          <div className="mb-8">
            <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-8">
              <motion.a
                href="/partner"
                whileHover={{ scale: 1.05 }}
                className="text-snowtxt hover:text-redtxt transition-colors duration-300 font-medium"
              >
                Partner with Us
              </motion.a>
              <div className="hidden md:block w-px h-6 bg-snowtxt"></div>
              <motion.a
                href="/privacypolicy"
                whileHover={{ scale: 1.05 }}
                className="text-snowtxt hover:text-redtxt transition-colors duration-300 font-medium"
              >
                Privacy Policy
              </motion.a>
              <div className="hidden md:block w-px h-6 bg-snowtxt"></div>
              <motion.a
                href="/terms"
                whileHover={{ scale: 1.05 }}
                className="text-snowtxt hover:text-redtxt transition-colors duration-300 font-medium"
              >
                Terms
              </motion.a>
            </div>
          </div>

          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex items-center justify-center gap-2 text-snowtxt"
          >
            <span>Made with</span>
            <motion.div
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            >
              <Heart className="w-5 h-5 text-redtxt fill-current" />
            </motion.div>
            <span>for hungry students</span>
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;